import type { CaptureImageResult } from './CaptureImageResult';
import type { CaptureTargetView, CaptureViewTarget } from './CaptureViewTarget';

// ビュー単体キャプチャの結果。viewName 指定や対象未指定でも呼び出し側が対象を特定できるよう、
// 解決済みのビューを画像と一緒に返す。
export type ViewImageCaptureResult = {
  view: CaptureTargetView;
  image: CaptureImageResult;
};

// キャプチャ操作の提供元。useViewImageCapture が返す関数を ViewModelPageContent が登録し、
// MCPブリッジ経由の JSON-RPC ハンドラと、AIアシスタントの getViewImage ツールの双方から参照する。
export type ViewImageCaptureAPI = {
  captureViewModelImage: () => Promise<CaptureImageResult>;
  captureViewImage: (target: CaptureViewTarget) => Promise<ViewImageCaptureResult>;
};

let _api: ViewImageCaptureAPI | null = null;

export const ViewImageCaptureLocator = {
  register(api: ViewImageCaptureAPI): void {
    _api = api;
  },
  unregister(api?: ViewImageCaptureAPI): void {
    if (api === undefined || _api === api) {
      _api = null;
    }
  },
  get(): ViewImageCaptureAPI | null {
    return _api;
  },
};
